import { motion } from "framer-motion";
import { Reveal, Eyebrow, EASE } from "@/components/Reveal";

const STEPS = [
  {
    n: "01",
    title: "Diagnose",
    desc: "Governance, delivery and risk maturity mapped in weeks, not quarters — against the standards your regulators recognise.",
  },
  {
    n: "02",
    title: "Design",
    desc: "Frameworks, operating model and a controls roadmap tailored to your regulatory reality and ambition.",
  },
  {
    n: "03",
    title: "Deploy",
    desc: "Embedded alongside your teams — working sessions, real artefacts, nothing left as slideware.",
  },
  {
    n: "04",
    title: "Sustain",
    desc: "Metrics, audits and iteration that keep pace with both the technology and the law.",
  },
];

export default function Approach() {
  return (
    <section id="approach" className="relative py-28 lg:py-36">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="flex flex-col justify-between gap-8 md:flex-row md:items-end">
          <div>
            <Reveal>
              <Eyebrow>The approach</Eyebrow>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-8 font-display text-4xl font-extrabold tracking-tighter sm:text-5xl">
                A method that ends <span className="text-accent">in evidence.</span>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2} className="max-w-sm">
            <p className="text-sm leading-relaxed text-slate-400 sm:text-base">
              Four moves, one outcome: assurance you can hand to a board, an auditor or a regulator.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              data-testid="approach-step"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.85, delay: i * 0.1, ease: EASE }}
              className="group relative border-l border-white/15 pl-6 lg:pl-8"
            >
              <span
                aria-hidden="true"
                className="absolute -left-px top-0 h-0 w-px bg-accent transition-all duration-700 group-hover:h-full"
              />
              <span className="font-mono text-xs tracking-[0.3em] text-accent">{s.n}</span>
              <h3 className="mt-5 font-display text-2xl font-bold tracking-tight">{s.title}</h3>
              <p className="mt-4 text-sm leading-relaxed text-slate-400">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
